module.exports = __webpack_public_path__ + "img/back2.9d86be7b.png";